var React = require('react');

function MapInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M60.4 8.3c-.3-.3-.8-.4-1.3-.3l-3.1.8C54.6 3.8 50 0 44.5 0c-6.3 0-11.4 4.9-11.9 11L21.9 8h-.6l-20 5c-.8.2-1.3.8-1.3 1.5v32c0 .5.2.9.6 1.2.2.2.6.3.9.3h.4l19.6-4.9L39.1 48h.6l20-5c.7-.2 1.1-.8 1.1-1.5v-32c.2-.5 0-.9-.4-1.2zM44.5 3c4.9 0 8.9 4 8.9 8.9 0 2.1-.7 4.1-2.1 5.7l-.1.1-6.8 9.1-6.8-9.2c-1.4-1.6-2.1-3.7-2.1-5.8.1-4.8 4.1-8.8 9-8.8zM3 15.7l17-4.3v28.9L3 44.6V15.7zm20 24.7V11.5l9.8 2.7c.4 2 1.3 3.8 2.5 5.4l2.7 3.6v21.4l-15-4.2zm35-.1l-17 4.3V27.2l2.3 3.1c.3.4.7.6 1.2.6s.9-.2 1.2-.6l8-10.7c1.8-2.1 2.7-4.8 2.7-7.6v-.1l1.6-.4v28.8z","key":0}),React.createElement("path",{"d":"M44.5 17.8c3.3 0 5.9-2.7 5.9-5.9S47.8 6 44.5 6s-5.9 2.7-5.9 5.9 2.6 5.9 5.9 5.9zm0-8.8c1.6 0 2.9 1.3 2.9 2.9s-1.3 2.9-2.9 2.9-2.9-1.3-2.9-2.9S42.9 9 44.5 9z","key":1})]);
}

MapInline.defaultProps = {"width":"61","height":"48","fill":"#5f29c7"};

module.exports = MapInline;

MapInline.default = MapInline;
